const style = {
    sideBarBorder: {
        border: "none",
        backgroundColor: "background.second"
    },
}

export default style;